import React from 'react'

// UrgencyBadge (design: Pages and UI components; Req 1.5)
//
// Renders a small colored badge for a ticket's urgency value. Each urgency in
// the restricted set (URGENCIES) maps to a distinct Tailwind color so the
// priority reads at a glance; unknown values fall back to a neutral style.
const URGENCY_CLASSES = {
  Low: 'bg-green-100 text-green-800',
  Medium: 'bg-blue-100 text-blue-800',
  High: 'bg-orange-100 text-orange-800',
  Critical: 'bg-red-100 text-red-800'
}

const UrgencyBadge = ({ urgency }) => {
  if (!urgency) return null

  const colorClass = URGENCY_CLASSES[urgency] || 'bg-gray-100 text-gray-800'

  return (
    <span
      className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${colorClass}`}
    >
      {urgency}
    </span>
  )
}

export default UrgencyBadge
